import { useAuth } from "../utils/auth";
import { useActiviteiten } from "../utils/activiteiten";
import { Link } from "react-router-dom";
import { formatDateShort } from "../helperfunctions/helperfunctions";
import "../css/homeStyling.css";
import ActiviteitenSoon from "../modules/UserDashboard/ActiviteitenSoon";
import MyActiviteiten from "../modules/UserDashboard/MyActiviteiten";

const Home = () => {

    const auth = useAuth();
    const act = useActiviteiten();

    return (
        <>
            <div className="home">
                <div className="homeContainer">
                    {
                        !auth.user &&
                        <>
                            <h3 className="welcomeMessage">Welkom bij de leden app van RV de Brinkruiters. </h3>

                            <p>Via deze app kun je je (als Brinkruiters lid) aanmelden als vrijwilliger voor diverse activiteiten.</p>

                            <p>Log in (<span>of maak een account aan als je die nog niet hebt </span>) en bekijk de aankomende activiteiten.</p>
                            
                        <Link to='/aanmelden'>Inloggen/ Account maken</Link>
                
                        </>
                    }

                    <div className="dashboardSection">
                        <ActiviteitenSoon />
                    {
                        auth.user && 

                        <>
                        
                        
                        
                        
                            

                            <div className="dashboardContainer">
                                <h3>Vrijwilligers gevraagd:</h3>
                                <div className="openActiviteiten">
                                    { act.openActiviteiten && act.openActiviteiten.map((item, i) => {
                                    const shownDatum = formatDateShort(item.datum);
                                    return (
                                            <div key={i} className="listItem">
                                                <span className="homeDatum">{shownDatum}</span>
                                                <span className="itemNaam">{item.naam}</span>
                                            </div>
                                    )
                                    })}

                                    { act.openActiviteiten && <p className="info">Klik op Activiteiten in het menu voor details van deze activiteiten en/of om je aan te melden als vrijwilliger.</p>}

                                    { !act.openActiviteiten && <p  className="info">Er zijn op dit moment geen activiteiten waarvoor nog vrijwilligers gezocht worden.</p>}
                                </div>
                            </div>

                            
                            <div className = "dashboardContainer">
                                <MyActiviteiten />
                            </div>

                        </>
                        
                    }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;